import React from 'react';
import Link from '../../misc/Link';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  notifications: { fontSize: '1.3em' },
  notification: {
    marginBottom: theme.spacing(3),
  },
}));

export default function YesNotifications(props) {
  const classes = useStyles();
  const { notifications } = props;

  return (
    <>
      {notifications.map((notification, i) => {
        let href = null;
        if (notification.type === 'account') href = '/account';
        if (notification.type === 'account/amazon') href = '/account/#amazon';
        if (notification.type === 'payment') href = '/remittance';
        if (notification.type === 'application') href = '/plans';
        if (notification.type === 'company') href = '/account/business';
        return (
          <li className={classes.notification} key={i}>
            <Link href={href} disabled={href ? false : true}>
              {notification.message} {href ? '>' : '.'}
            </Link>
          </li>
        );
      })}
    </>
  );
}
